import api from '../lib/axios';
// Catalogue public (national)
export async function searchNationalProcedures(params) {
    const { data } = await api.get('/api/v1/national-procedures', { params });
    return data;
}
export async function getNationalProceduresCategories() {
    const { data } = await api.get('/api/v1/national-procedures/categories');
    return data.data;
}
// Épinglages partenaires
export async function getFeaturedProcedures() {
    const { data } = await api.get('/api/admin/procedures-featured');
    return data.data;
}
export async function pinProcedure(procedureId, localNote) {
    const { data } = await api.post('/api/admin/procedures-featured', {
        procedure_id: procedureId,
        local_note: localNote ?? null,
    });
    return data.data;
}
export async function updateFeaturedNote(id, localNote) {
    const { data } = await api.patch(`/api/admin/procedures-featured/${id}`, {
        local_note: localNote,
    });
    return data.data;
}
export async function reorderFeatured(ids) {
    await api.post('/api/admin/procedures-featured/reorder', { ids });
}
export async function unpinProcedure(id) {
    await api.delete(`/api/admin/procedures-featured/${id}`);
}
